import React from 'react';
import { Tooltip } from 'reactstrap';

const phoneNumberPattern = /^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/;

export default class PhoneNumber extends React.Component {
    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.validateOnMount = this.validateOnMount.bind(this);
        this.clearInput = this.clearInput.bind(this);
        const { value } = this.props;
        this.state = {
            tooltipOpen: false,
            invalidInput: false
        };
    }

    componentDidMount() {
        const { setFocus, phoneNumberId, validateOnMount } = this.props;
        if (setFocus) {
            const input = document.getElementById(phoneNumberId);
            if (input) {
                input.focus();
            }
        }
        if (validateOnMount) {
            this.validateOnMount();
        }
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    isNumericInput = (event) => {
        const key = event.keyCode;
        return ((key >= 48 && key <= 57) || // Allow number line
            (key >= 96 && key <= 105) // Allow number pad
        );
    };
    
    isModifierKey = (event) => {
        const key = event.keyCode;
        return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
            (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
            (key > 36 && key < 41) || // Allow left, up, right, down
            (
                (event.ctrlKey === true || event.metaKey === true) &&
                (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
            )
    };

    onKeyPress = (event) => {
        if(!this.isNumericInput(event) && !this.isModifierKey(event)){
            event.preventDefault();
        }
    };

    onKeyUp = (e) => {      
        if (this.isModifierKey(e)) { return; }       
        var formatTarget = e.target;
        const input = e.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
        const first = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);
        if (input.length > 5) {
            formatTarget.value = `${first}.${middle}.${last}`;
        } else if (input.length > 2) {
            formatTarget.value = `${first}.${middle}`;
        } else if (input.length > 0) {
            //this.setState({ invalidInput: false });
            formatTarget.value = `${first}`;
        }
        
    }

    onChange(event) {
        const { value } = event.target;
        const isValid = this.isValid(value);

        if (this.props.onChange) {
            this.props.onChange(event, isValid);
        }

        if (this.state.invalidInput) {
            this.setState({
                invalidInput: !isValid
            });
        }

    }

    isValid(value) {  
        if (value) {
            return value.trim() && phoneNumberPattern.test(value);
        }
        else {
            return this.props.required ? false : true;
        }

    }

    clearInput(event) {
        const e = { event, target: { value: "", name: this.props.name ? this.props.name : "" } };
        this.onChange(e);
    }

    validateOnBlur(event) {
        const value = event.target.value;
        const isValid = this.isValid(value);

        if (this.props.onChange) {
            this.props.onChange(event, isValid);
        }

        event.persist();
        this.setState({ invalidInput: !isValid });
    }

    validateOnMount() {
        const value = this.props.value;
        const isValid = this.isValid(value);
        this.setState({ invalidInput: !isValid });
    }
    
    render() {
        const { placeholder, value, phoneNumberId, required, name, id, autoFocus, disabled,
            inputErrorMsg, tooltipID, tooltipMsg, showAsInvalid, showClearBtn, autoComplete
        } = this.props;
        const isValid = this.isValid(value);
        const containerClassName = (value ? " input-not-empty" : "") + (this.state.invalidInput || showAsInvalid ? " input-invalid" : "") + ((tooltipID && tooltipMsg) ? " input-append" : "");

        return (
            <div className={"il-group" + containerClassName}>
                <input type="text" id={phoneNumberId} 
                    autoComplete={autoComplete}
                    className="form-control"
                    value={ value }
                    required = { required }
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : "Phone Number"} maxLength={12}
                    onKeyUp={e => this.onKeyUp(e)} onKeyDown={e => this.onKeyPress(e)}
                    onChange={e => this.onChange(e)} 
                    onBlur={this.validateOnBlur}
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out the Phone Number."}
                    ref="inputElement"
                    aria-label={placeholder ? placeholder : 'Phone Number'}
                />
                {(tooltipID && tooltipMsg) && <div className="input-icon-append">
                    <span className="icon-info" id={tooltipID} />
                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleTooltip}>
                        {tooltipMsg}
                    </Tooltip>
                </div>}
                {showClearBtn && value &&
                    <div className="clear-btn-container">
                        <button className="clear-btn" type="button" aria-label="clear button" onClick={this.clearInput}><span className="icon-input-clear" /></button>
                    </div>
                }
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                {inputErrorMsg ? <div className="input-error-msg">{inputErrorMsg}</div> : !isValid && (typeof value !== "undefined" && value) && <div className="input-error-msg">{`Please enter a valid ${ placeholder? placeholder: "phone number" }.`}</div>}
            </div>    
        );
    }
}